export default __webpack_public_path__ + "static/media/aboutBgDescriptionMobile.d1136253.png";